import { render, staticRenderFns } from "./getUserReportInstagram.vue?vue&type=template&id=0a2e3e22&scoped=true&"
import script from "./getUserReportInstagram.vue?vue&type=script&lang=js&"
export * from "./getUserReportInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2e3e22",
  null
  
)

export default component.exports